module.exports = __webpack_public_path__ + "ecb4af52999aaee9a085a7bfe98a6ae2.png";